module.exports = __webpack_public_path__ + "img/grid-1x2-fill.8300477b.svg";